<template>
    <v-layout>
        <v-flex>
            <v-card-text>
                <v-container grid-list-md py-2>
                    <v-layout row wrap>
                        <v-flex>
                            <v-layout>
                                <v-flex>
                                    <h3>Traitement : {{ getText(selectedTreatment.type) }}</h3>
                                    <h3 v-if="selectedTreatment.sub_type">Type : {{ getText(selectedTreatment.sub_type) }}</h3>
                                    <h3 v-if="selectedTreatment.surgery_side">Coté opéré : {{ getText(selectedTreatment.surgery_side) }}</h3>
                                    <h3>Diagnostique : {{ getText(selectedTreatment.medical_case.diagnostic.type)
                                        }}</h3>

                                    <div>
                                        Ouvert le : {{ selectedTreatment.created_at | shortDate }}
                                    </div>

                                    <div>
                                        <b>Date d'intervention : {{ selectedTreatment.intervention_date | shortDate }}</b>
                                    </div>

                                    <p>{{ selectedTreatment.description }}</p>

                                </v-flex>
                                <v-flex>
                                    <h4 v-if="selectedTreatment.resurfacing != null">Resurfaçage rotule : {{ selectedTreatment.resurfacing ? 'Oui' : 'Non' }}</h4>
                                    <h4 v-if="selectedTreatment.alignment != null">Alignement : {{ selectedTreatment.alignment == 'ALIGNMENT_MECHANIC' ? 'Mécanique' : 'Cinématique' }}</h4>
                                    <h4 v-if="selectedTreatment.already_operated != null">Genou déjà opéré : {{ selectedTreatment.already_operated ? 'Oui' : 'Non' }}</h4>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-btn flat @click="treatmentModal()" v-if="selectedTreatment.open || selectedTreatment.closing_reason === 'PAUSED'">
                                    <v-icon>edit</v-icon>
                                </v-btn>

                                <v-btn color="primary" text @click="tagtModal()" v-if="selectedTreatment.open">
                                    TAGT
                                </v-btn>

                                <v-btn color="primary" text @click="confirmModal()" v-if="selectedTreatment.open">
                                    <v-icon>mdi-doctor</v-icon>
                                    Médecin
                                </v-btn>
                                <v-btn color="primary" text @click="confirmEvolutionModal()" v-if="hasEvolutions">
                                    Évolution du patient
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-dialog max-width="600px" persistent v-model="showTreatmentForm" v-if="selectedTreatment.open || selectedTreatment.closing_reason === 'PAUSED'">
                            <treatment-form></treatment-form>
                        </v-dialog>
                        <protected-dialog :confirm-dialog="confirmDialog" :modal-to-open="doctorModal" @dialog-closed="onDialogClosed">

                        </protected-dialog>

                        <v-dialog max-width="600px" persistent v-model="showTagtForm" v-if="selectedTreatment.open">
                            <tagt-form></tagt-form>
                        </v-dialog>

                        <v-dialog max-width="600px" persistent v-model="showRevisionForm" v-if="selectedTreatment.open">
                            <revision-form></revision-form>
                        </v-dialog>
                    </v-layout>
                    <v-layout row wrap class="treatment-card-list">
                        <v-flex sm4 v-for="(followUps, name, index) in groupedFollowUps" id="caca" :key="'followUp-' + name">
                            <v-card class="display-flex flex-column">
                                <v-card-title class="flex-shrink-1">
                                    <span v-if="name" class="headline">{{(name === 'Pre-op' || name === 'preop') ? 'Pré-op' : name}}</span>
                                    <v-spacer></v-spacer>
                                    <v-btn flat icon color="primary" class="ma-0" v-if="followUps[followUps.length - 1].completed"
                                           @click="showResult(followUps[0].id)">
                                        <v-icon>mdi-eye-check-outline</v-icon>
                                    </v-btn>
                                    <v-btn v-else flat icon disabled class="ma-0"><v-icon>null</v-icon></v-btn>
                                </v-card-title>
                                <v-card-text class="flex-grow-1">
                                    <div class="mb-2">
                                        Statut : {{ getTextStatus(currentFollowUp(followUps)) }} le {{ currentFollowUp(followUps).updated_at | shortDate }}
                                        <template v-if="!currentFollowUp(followUps).completed && (currentFollowUp(followUps).completed_patient || currentFollowUp(followUps).completed_doctor)">
                                            <p v-if="currentFollowUp(followUps).show_doctor_label && currentFollowUp(followUps).completed_doctor">Suivi terminé par le docteur</p>
                                            <p v-if="currentFollowUp(followUps).completed_patient">Suivi terminé par le patient</p>
                                        </template>

                                    </div>
                                    <div class="mb-2">
                                        <div v-if="currentFollowUp(followUps).follow_up_definition && currentFollowUp(followUps).follow_up_definition.follow_up_notifications.length > 0">
                                            <div v-for="notification in currentFollowUp(followUps).follow_up_definition.follow_up_notifications" :key="notification.id">
                                                <div v-if="notification.target === 'patient' && notification.type !== 'manual'">
                                                    Patient notifié le : {{ notification.created_at  | shortDate }} <v-icon color="success">done</v-icon>
                                                </div>
                                                <div v-else-if="notification.target === 'doctor'">
                                                    Docteur notifié le : {{ notification.created_at  | shortDate }} <v-icon color="success">done</v-icon>
                                                </div>
                                                <div v-else-if="notification.target === 'nurse'">
                                                    Secretariat notifié le : {{ notification.created_at  | shortDate }} <v-icon color="success">done</v-icon>
                                                </div>
                                                <div v-else v-if="notification.type === 'manual'">
                                                    Notification manuelle le : {{ notification.created_at  | shortDate }} <v-icon color="success">done</v-icon>
                                                </div>

                                            </div>
                                        </div>
                                        <div v-else>&nbsp;</div>
                                    </div>

                                    <h4>Scores:</h4>
                                    <template v-if="followUps.length > 0 && followUps[0].follow_up_definition.study_id && followUps[0].id">
                                        <ul>
                                        <template v-for="score in scoresForFollowUps(followUps)">
                                            <template v-if="score">
                                                <li>
                                                    {{ score[0].score.name }} ({{ formatScoreConcern(score[0].score) }})
                                                </li>
                                            </template>
                                        </template>
                                        </ul>
                                    </template>
                                    <template v-else-if="followUps[0].follow_up_definition.study_id == null">
                                        <ul> {{  }}
                                            <template v-for="score in followUps[0].follow_up_scores">
                                                <template v-if="score">
                                                    <li>
                                                        {{ score.score.name }} ({{ formatScoreConcern(score.score) }})
                                                    </li>
                                                </template>
                                            </template>
                                        </ul>
                                    </template>
                                    <div v-if="selectedTreatment.open && ((followUps[0].follow_up_definition.study_id !== null && followUps[0].follow_up_definition.follow_up_score_definitions && followUps[0].follow_up_definition.follow_up_score_definitions.length) || (followUps[0].follow_up_definition.study_id == null && followUps[0].follow_up_definition.score_definitions && followUps[0].follow_up_definition.score_definitions.length))"
                                    >
                                        <div class="d-flex mt-2">
                                            <follow-up-url
                                                :step="followUps[0].follow_up_definition.id"
                                                :treatment="selectedTreatment.id"
                                                concern="patient"
                                            ></follow-up-url>
                                            <follow-up-url
                                                v-if="hasFollowupScoreGroupForDoctor(followUps[0].follow_up_definition)"
                                                :step="followUps[0].follow_up_definition.id"
                                                :treatment="selectedTreatment.id"
                                                concern="doctor"
                                            ></follow-up-url>
                                        </div>
                                        <v-btn primary @click="confirmSendNotificationModal(followUps[0].follow_up_definition.id)">
                                            <v-icon>mdi-send</v-icon> &nbsp;Envoyer notification
                                        </v-btn>
                                    </div>
                                </v-card-text>
                                <v-card-actions v-if="(currentFollowUp(followUps).follow_up_definition.follow_up_score_definitions && currentFollowUp(followUps).follow_up_definition.follow_up_score_definitions.length) || currentFollowUp(followUps).follow_up_definition.study_id == null" class="flex-shrink-1">
                                    <template
                                        v-if="selectedTreatment.open && followUps.some((followup) => followup.follow_up_definition.position == (selectedTreatment.next_follow_up.follow_up_definition ? selectedTreatment.next_follow_up.follow_up_definition.position : selectedTreatment.next_follow_up.position))">
                                        <v-btn
                                            v-if="!currentFollowUp(followUps).completed_patient && hasScoreGroupForPatientInProgress(currentFollowUp(followUps))"
                                            flat text color="primary"
                                               @click="showModal(currentFollowUp(followUps).follow_up_definition_id)">
                                            {{ currentFollowUp(followUps).follow_up_scores_patient.length > 0 ? 'Continuer patient' : 'Commencer patient' }}
                                        </v-btn>
                                        <v-btn
                                            v-if="!currentFollowUp(followUps).completed_doctor && hasScoreGroupForDoctorInProgress(currentFollowUp(followUps))"
                                            flat color="primary"
                                               @click="showDoctorFollowUpModal(currentFollowUp(followUps).follow_up_definition_id)">
                                            {{ currentFollowUp(followUps).follow_up_scores_doctor.length > 0 ? 'Continuer docteur' : 'Commencer docteur' }}
                                        </v-btn>
                                        <v-btn flat text color="secondary"
                                               @click="showSkipModal(currentFollowUp(followUps).follow_up_definition_id)">Passer
                                        </v-btn>
                                    </template>
                                    <v-btn v-else-if="currentFollowUp(followUps).completed" flat class=" custom-disabled">
                                        <v-icon color="green darken-1" medium>mdi-calendar-check</v-icon>
                                    </v-btn>
                                    <v-btn v-else-if="currentFollowUp(followUps).skip" flat class="custom-disabled">
                                        <v-icon color="red darken-2" medium>mdi-calendar-remove</v-icon>
                                    </v-btn>
                                    <v-btn v-else flat icon disabled>
                                        <v-icon color="grey darken-1" medium>mdi-calendar-clock</v-icon>
                                    </v-btn>
                                    <v-btn v-if="currentFollowUp(followUps).completed
                                    && !currentFollowUp(followUps).deleted_at
                                    && currentFollowUp(followUps).follow_up_definition.position === 0
                                    && index === (groupedFollowUps.length - 1)" flat color="primary" @click="restart(currentFollowUp(followUps).id)">FAIRE A NOUVEAU</v-btn>

                                </v-card-actions>
                            </v-card>
                        </v-flex>
                        <v-flex sm4 v-for="followUp in selectedTreatment.next_follow_ups " :key="followUp.id">
                            <v-card class="display-flex flex-column">
                                <v-card-title class="flex-shrink-1">
                                    <span class="headline">{{ (followUp.name === 'Pre-op' || followUp.name === 'preop') ? 'Pré-op' : followUp.name }}</span>
                                    <v-spacer></v-spacer>
                                    <v-btn flat icon disabled class="ma-0"><v-icon>null</v-icon></v-btn>
                                </v-card-title>
                                <v-card-text class="flex-grow-1">
                                    <div class="mb-2">
                                        Statut : {{ selectedTreatment.open === 1 ? getTextStatus('FOLLOW_UP_STATUS_NEXT') : 'Fermé'}}                                    </div>
                                    <div class="mb-2">
                                        <notification-date v-if="selectedTreatment.open === 1"
                                            :follow-up="followUp"
                                            :patient="selectedPatient"
                                            :for-doctor="hasScoreGroupForDoctor(followUp)"
                                            :for-patient="hasScoreGroupForPatient(followUp)"
                                        />
                                    </div>

                                    <h4>Scores:</h4>
                                    <ul v-if="followUp.study_id !== null && followUp.score_definitions && followUp.score_definitions.length">
                                        <li v-for="score in filterScoreDefinition(followUp)" :key="'followup-' + followUp.id + '-' + score.score.id">
                                            {{score.score.name}} ({{ formatScoreConcern(score.score) }})
                                        </li>
                                    </ul>
                                    <ul v-else-if="followUp.study_id == null && followUp.score_definitions && followUp.score_definitions.length">
                                        <li v-for="score in filterScoreDefinition(followUp)" :key="'followup-' + followUp.id + '-' + score.score.id">
                                            {{score.score.name}} ({{ formatScoreConcern(score.score) }})
                                        </li>
                                    </ul>
                                    <p v-else>Aucun score disponible pour ce diagnostique</p>
                                    <div v-if="selectedTreatment.open && ((followUp.study_id !== null && followUp.follow_up_score_definitions && followUp.follow_up_score_definitions.length) || (followUp.study_id == null && followUp.score_definitions && followUp.score_definitions.length))"

                                    >
                                        <div class="d-flex mt-2">
                                            <follow-up-url
                                                :step="followUp.id"
                                                :treatment="selectedTreatment.id"
                                                concern="patient"
                                            ></follow-up-url>
                                            <follow-up-url
                                                v-if="hasScoreGroupForDoctor(followUp)"
                                                :step="followUp.id"
                                                :treatment="selectedTreatment.id"
                                                concern="doctor"
                                            ></follow-up-url>
                                        </div>
                                        <v-btn primary @click="confirmSendNotificationModal(followUp.id)">
                                            <v-icon>mdi-send</v-icon> &nbsp;Envoyer notification
                                        </v-btn>
                                    </div>
                                </v-card-text>
                                <v-card-actions v-if="selectedTreatment.open && (followUp.follow_up_score_definitions && followUp.follow_up_score_definitions.length)" class="flex-shrink-1">
                                    <template v-if="followUp.id === selectedTreatment.next_follow_up.id">
                                        <v-btn
                                            v-if="hasFollowupScoreGroupForPatient(followUp)"
                                            flat
                                            color="primary"
                                            @click="showModal(followUp.id)">
                                            Commencer patient
                                        </v-btn>
                                        <v-btn
                                            v-if="hasFollowupScoreGroupForDoctor(followUp)"
                                            flat
                                            color="primary"
                                            @click="showDoctorFollowUpModal(followUp.id)">
                                            Commencer docteur
                                        </v-btn>
                                        <v-btn flat color="secondary" @click="showSkipModal(followUp.id)">Passer</v-btn>
                                    </template>
                                    <v-btn v-else flat disabled>
                                        <v-icon color="grey darken-1" medium>mdi-calendar-clock</v-icon>
                                    </v-btn>
                                </v-card-actions>
                                <v-card-actions v-else-if="selectedTreatment.open && (followUp.study_id == null && followUp.score_definitions && followUp.score_definitions.length)" class="flex-shrink-1">
                                    <template v-if="followUp.id === selectedTreatment.next_follow_up.id">
                                        <v-btn
                                            v-if="hasScoreGroupForPatient(followUp)"
                                            flat
                                            color="primary"
                                            @click="showModal(followUp.id)">
                                            Commencer patient
                                        </v-btn>
                                        <v-btn
                                            v-if="hasScoreGroupForDoctor(followUp)"
                                            flat
                                            color="primary"
                                            @click="showDoctorFollowUpModal(followUp.id)">
                                            Commencer docteur
                                        </v-btn>
                                        <v-btn flat color="secondary" @click="showSkipModal(followUp.id)">Passer</v-btn>
                                    </template>
                                    <v-btn v-else flat disabled>
                                        <v-icon color="grey darken-1" medium>mdi-calendar-clock</v-icon>
                                    </v-btn>
                                </v-card-actions>
                                <v-card-actions v-else class="flex-shrink-1">
                                    <v-btn flat disabled>
                                        <v-icon color="grey darken-1" medium>null</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                    </v-layout>
                    <v-layout justify-center>
                        <v-dialog v-model="dialog" persistent max-width="480">
                            <v-card>
                                <v-card-title class="headline">Suivi Patient</v-card-title>
                                <v-card-text>Voulez-vous vérouiller la tablette et activer la saisie patient ?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="secondary" text @click="startScore(false)">Non, continuer</v-btn>
                                    <v-btn color="primary" text @click="startScore(true)">Oui, verrouiller</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog_doctor" persistent max-width="480">
                            <v-card>
                                <v-card-title class="headline">Suivi Docteur</v-card-title>
                                <v-card-text>Voulez-vous vérouiller la tablette et activer la saisie docteur ?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="secondary" text @click="startScore(false, 'doctor')">Non, continuer</v-btn>
                                    <v-btn color="primary" text @click="startScore(true, 'doctor')">Oui, verrouiller</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog_skip" persistent max-width="480">
                            <v-card>
                                <v-card-title class="headline">Passer le suivi</v-card-title>
                                <v-card-text>Etes-vous sûr vouloir de passer ce suivi ?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="secondary" text @click="dialog_skip = false">Non</v-btn>
                                    <v-btn color="primary" text @click="skipScore()">Oui</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="confirmSendNotificationDialog" persistent max-width="480">
                            <v-card>
                                <v-card-title class="headline">Confirmer la notification</v-card-title>
                                <v-card-text>Etes-vous sûr vouloir notifier le patient ?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="secondary" text @click="confirmSendNotificationDialog = false">Non</v-btn>
                                    <v-btn color="primary" text @click="sendManualNotification">Oui</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="confirmEvolutionDialog" persistent max-width="480">
                            <v-card>
                                <v-card-title class="headline">Évolution du patient</v-card-title>
                                <v-card-text>Voulez-vous vérouiller la tablette et activer la saisie patient ?
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="secondary" text @click="evolution(false)">Non, continuer
                                    </v-btn>
                                    <v-btn color="primary" text @click="evolution(true)">Oui, verrouiller</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex';
    import TreatmentForm from "../treatment/TreatmentForm";
    import RevisionForm from "../treatment/RevisionForm";
    import FollowUpUrl from "./FollowUpUrl";
    import {getTranslationString} from "../../../helper";
    import NotificationDate from "./NotificationDate";
    import ProtectedDialog from "../dialog/ProtectedDialog";
    import TagtForm from "./TagtForm.vue";

    export default {
        name: "TreatmentView",
        components: {
            'tagt-form': TagtForm,
            'treatment-form': TreatmentForm,
            'revision-form': RevisionForm,
            FollowUpUrl,
            NotificationDate,
            ProtectedDialog,
        },
        data: () => ({
            dialog: false,
            dialog_doctor: false,
            dialog_skip: false,
            locked: false,
            selectedFollowUpDefinition: null,
            confirmDialog: false,
            confirmSendNotificationDialog: false,
            confirmEvolutionDialog: false,
        }),
        created() {
            this.setSelectedMedicalCaseId(this.$route.params.medical_case_id)
            this.setSelectedTreatmentId(this.$route.params.treatment_id)
            this.getTreatmentInfo()
        },
        computed: {
            ...mapState('medical_cases', {
                selectedMedicalCase: state => state.selectedMedicalCase,
            }),
            ...mapState('treatments', {
                selectedTreatment: state => state.selectedTreatment,
                showTreatmentForm: state => state.showForm,
                showRevisionForm: state => state.showRevisionForm,
                showTagtForm: state => state.showTagtForm,
            }),
            ...mapState('patients', {
                selectedPatient: state => state.selectedPatient,
            }),
            groupedFollowUps() {
                return this.selectedTreatment?.follow_ups.reduce(function(grouped, followUp) {
                    (grouped[followUp.follow_up_definition.name] = grouped[followUp.follow_up_definition.name] || []).push(followUp);
                    return grouped;
                }, {});
            },
            hasEvolutions() {
                return this.selectedTreatment?.follow_ups.filter(followUp => followUp.completed).length > 0
            },
        },
        methods: {
            ...mapMutations(['updateLockedState']),
            ...mapMutations('medical_cases', [
                'setSelectedMedicalCaseId'
            ]),
            ...mapActions(["validateUnlock"]),
            ...mapActions('treatments', [
                'getTreatmentInfo',
            ]),
            ...mapActions('follow_ups', ['createFollowUp', 'restartFollowUp', 'sendNotification']),
            ...mapMutations('treatments', [
                'setSelectedTreatmentId', 'initForm', 'initTagtForm', 'setShowForm', 'initRevisionForm', 'setShowRevisionForm', 'resetForm',
                'setTagtFormPreop', 'setTagtFormPostop', 'setShowTagtForm'
            ]),
            ...mapMutations('studies', [
                'setSelectedFollowUpDefinitionId'
            ]),
            getText(key) {
                return getTranslationString(key)
            },
            getTextStatus(followUp) {
                if (followUp.skip) {
                    return this.getText('FOLLOW_UP_STATUS_SKIP')
                } else {
                    return followUp.completed ? this.getText('FOLLOW_UP_STATUS_COMPLETED') : this.getText('FOLLOW_UP_STATUS_UNCOMPLETED')
                }
            },
            treatmentModal() {
                this.initForm(this.selectedTreatment);
                this.setShowForm(true);
            },

            tagtModal() {
                this.initTagtForm(this.selectedTreatment);
                this.setShowTagtForm(true);
            },

            confirmSendNotificationModal(followUpDefinitionId) {
                this.setSelectedFollowUpDefinitionId(followUpDefinitionId);
                this.confirmSendNotificationDialog = true;
            },
            sendManualNotification() {
                this.sendNotification().then(response => {
                    this.confirmSendNotificationDialog = false;
                    this.getTreatmentInfo()
                }).catch(reason => {
                    //Stay here..
                })
            },
            confirmModal() {
                this.confirmDialog = true;
            },
            onDialogClosed() {
                this.confirmDialog = false;
            },
            doctorModal() {
                this.initRevisionForm(this.selectedTreatment);
                this.setShowRevisionForm(true);
                this.confirmDialog = false;
            },
            showModal(followUpDefinition) {
                this.dialog = true;
                this.selectedFollowUpDefinition = followUpDefinition
            },
            showDoctorFollowUpModal(followUpDefinition) {
                this.dialog_doctor = true;
                this.selectedFollowUpDefinition = followUpDefinition
            },
            showSkipModal(followUpDefinition) {
                this.dialog_skip = true;
                this.selectedFollowUpDefinition = followUpDefinition
            },
            startScore(locked, concern = 'patient') {
                if (this.selectedFollowUpDefinition != null) {
                    this.createFollowUp({
                        follow_up_definition_id: this.selectedFollowUpDefinition,
                        skip: false
                    }).then(response => {
                        this.$router.push({
                            name: 'patient.openFollowUp', params: {
                                locked: locked,
                                concern: concern,
                                back: this.$route.fullPath,
                                patient_id: this.selectedPatient.id,
                                medical_case_id: this.selectedMedicalCase.id,
                                treatment_id: this.selectedTreatment.id,
                                follow_up_id: response.data.follow_up.id
                            }
                        })

                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            showResult(followUp) {
                this.$router.push({
                    name: 'patient.viewFollowUp', params: {
                        patient_id: this.selectedPatient.id,
                        medical_case_id: this.selectedMedicalCase.id,
                        treatment_id: this.selectedTreatment.id,
                        follow_up_id: followUp
                    }
                })
            },
            skipScore() {
                if (this.selectedFollowUpDefinition != null) {
                    this.createFollowUp({
                        follow_up_definition_id: this.selectedFollowUpDefinition,
                        skip: true
                    }).then(response => {
                        this.dialog_skip = false
                        this.getTreatmentInfo()
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            restart(followupId) {
                if (followupId != null) {
                    this.restartFollowUp({
                        followup_id: followupId
                    }).then(response => {
                        this.getTreatmentInfo()
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            formatFollowUpScore(followup, rule) {
                if (rule === 'list') {
                    return this.getAllAnswersList(followup)
                } else {
                    return this.formatScore(followup.value, rule)
                }
            },
            formatScore(score, rule) {
                if (rule === 'sum') {
                    return score.toFixed(2)
                } else {
                    return score.toFixed(2) + " % "
                }
            },
            getAllAnswersList(followUp) {
                return followUp.groups.map(
                    (group) => this.getGroupAnswersList(followUp, group)
                ).join(", ")
            },

            getGroupAnswersList(followUp, group) {
                return this.getQuestionForGroup(followUp.details, group.score_group.id).map(
                    (detail) => detail.score_question_answer.text
                ).join(", ")
            },
            getQuestionForGroup(questionsDetails, groupId) {
                let results = [];
                for (let i = 0; i < questionsDetails.length; i++) {
                    let detail = questionsDetails[i];
                    if (detail.score_question.score_group_id === groupId) {
                        results.push(detail);
                    }
                }
                return results;
            },
            filterFollowUpScoreDefinition(followUp) {
              return followUp.follow_up_score_definitions.filter(item => item.max_step == null || (item.max_step >= followUp.position)).filter(item => item.min_step == null || (item.min_step <= followUp.position))
            },
            filterScoreDefinition(followUp) {
              return followUp.score_definitions.filter(item => item.max_step == null || (item.max_step >= followUp.position)).filter(item => item.min_step == null || (item.min_step <= followUp.position))
            },
            filterInProgressFollowUpScoreDefinition(followUp) {
              return followUp.follow_up_definition.follow_up_score_definitions.filter(item => item.max_step == null || (item.max_step >= followUp.position)).filter(item => item.min_step == null || (item.min_step <= followUp.position))
            },
            filterInProgressScoreDefinition(followUp) {
              return (followUp.score_definitions ? followUp.score_definitions : (followUp.follow_up_definition.follow_up_score_definitions ? followUp.follow_up_definition.follow_up_score_definitions : this.selectedTreatment.scores_definition)).filter(item => item.max_step == null || (item.max_step >= followUp.position)).filter(item => item.min_step == null || (item.min_step <= followUp.position))
            },
            scoresForFollowUps(followUps) {
                let followUpScores = [];
                for (const followup of followUps) {
                    for (const score of followup.follow_up_definition.follow_up_score_definitions) {
                        (followUpScores[score.score.id] = followUpScores[score.score.id] || []).push(score);
                    }
                }
                return followUpScores;
            },
            formatScoreConcern(score) {
                return score.has_patient_score_group ? (
                    score.has_doctor_score_group ? 'Patient & Docteur' : 'Patient'
                ) : (score.has_doctor_score_group ? 'Docteur' : '')
            },
            hasFollowupScoreGroupForPatientInProgress(followUp) {
                return this.filterInProgressFollowUpScoreDefinition(followUp).some(item => item.score.has_patient_score_group)
            },
            hasFollowupScoreGroupForDoctorInProgress(followUp) {
                return this.filterInProgressFollowUpScoreDefinition(followUp).some(item => item.score.has_doctor_score_group)
            },
            hasScoreGroupForPatientInProgress(followUp) {
                return this.filterInProgressScoreDefinition(followUp).some(item => item.score.has_patient_score_group)
            },
            hasScoreGroupForDoctorInProgress(followUp) {
                return this.filterInProgressScoreDefinition(followUp).some(item => item.score.has_doctor_score_group)
            },
            hasFollowupScoreGroupForPatient(followUp) {
                return this.filterFollowUpScoreDefinition(followUp).some(item => item.score.has_patient_score_group)
            },
            hasScoreGroupForPatient(followUp) {
                return this.filterScoreDefinition(followUp).some(item => item.score.has_patient_score_group)
            },
            hasFollowupScoreGroupForDoctor(followUp) {
                return this.filterFollowUpScoreDefinition(followUp).some(item => item.score.has_doctor_score_group)
            },
            hasScoreGroupForDoctor(followUp) {
                return this.filterScoreDefinition(followUp).some(item => item.score.has_doctor_score_group)
            },
            currentFollowUp(followUps) {
                let current = followUps.find((followUp) => !followUp.completed);
              return current ? current : followUps[followUps.length - 1];
            },
            confirmEvolutionModal() {
                this.confirmEvolutionDialog = true;
            },
            evolution(locked) {
                this.confirmEvolutionDialog = false;
                this.$router.push({
                    name: 'patient.viewEvolutionScore', params: {
                        locked: locked,
                        back: this.$route.fullPath,
                        patient_id: this.selectedPatient.id,
                        medical_case_id: this.selectedMedicalCase.id,
                        treatment_id: this.selectedTreatment.id,
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .custom-disabled {
        box-shadow: none !important;
        pointer-events: none;
    }
</style>
